import { MYHProductDataModel, MYHProductModel } from "@gaiaProfessionals/Services/MeetYourHerbsService";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

interface GAIAMYHProductDetailState {
    isLoading: boolean;
    product: MYHProductModel | undefined;
    productData: MYHProductDataModel | undefined;
    successful: boolean | undefined
}
const initialState: GAIAMYHProductDetailState = { isLoading: false, product: undefined, productData: undefined, successful: undefined };

const reducer = createTypedReducerWithImmer(initialState, {
    "Custom/MeetYourHerbs/BeginLoadProduct": (draft: Draft<GAIAMYHProductDetailState>) => {
        draft.isLoading = true;
    },
    "Custom/MeetYourHerbs/CompleteLoadProduct": (
        draft: Draft<GAIAMYHProductDetailState>,
        action: { product: GAIAMYHProductDetailState["product"], productData: GAIAMYHProductDetailState['productData'], successful: GAIAMYHProductDetailState['successful']  },
    ) => {
        draft.isLoading = false;
        draft.product = action.product;
        draft.productData = action.productData;
        draft.successful = action.successful;
    },
});

(reducers as any).customMeetYourHerbsReducer = reducer;

export type CustomMeetYourHerbsState = {
    customMeetYourHerbsReducer: GAIAMYHProductDetailState;
} & ApplicationState;

type Reducers = {
    customMeetYourHerbsReducer: typeof reducer;
};

export type CustomMeetYourHerbsActions = Parameters<Reducers[keyof Reducers]>[1] | AnyAction;
